module.exports = __webpack_public_path__ + "static/media/trip_empty.46b8e8ae.png";